import React from 'react';
import './assets/js/vendor/jquery.js';
import './assets/js/vendor/swiper.js';
import './assets/js/vendor/wow.js'
import './assets/js/vendor/sal.js';
import './assets/js/main.js';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePage from "./pages/ClientPage/HomePage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import CourseListPage from "./pages/AdminPage/Course/CourseList";
import SignInLayer from "./pages/AuthPage/SignInLayer";
import SignUpLayer from "./pages/AuthPage/SignUpLayer";
import OtpVerification from "./pages/AuthPage/OtpVerification";
import WithoutNav from "./masterLayout/WithoutNav";
import WithNav from "./masterLayout/WithNav";
import AddCourse from "./pages/AdminPage/Course/AddCourse";
import ViewCourse from "./pages/AdminPage/Course/ViewCourse";
import AddonPacksList from "./pages/AdminPage/AddonPacks/AddonPacksList";
import AddAddonPacks from "./pages/AdminPage/AddonPacks/AddAddonPacks";
import ViewAddonPacks from "./pages/AdminPage/AddonPacks/ViewAddonPacks";
import VouchersList from './pages/AdminPage/Vouchers/VouchersList';
import AddVouchers from "./pages/AdminPage/Vouchers/AddVouchers";
import ViewVouchers from "./pages/AdminPage/Vouchers/ViewVouchers";
import AnnouncementsList from "./pages/AdminPage/Anouncements/AnouncementsList";
import AddAnnouncements from "./pages/AdminPage/Anouncements/AddAnouncements";
import ViewAnnouncements from "./pages/AdminPage/Anouncements/ViewAnouncements";
import LiveSessionsList from "./pages/AdminPage/LiveSessions/LiveSessionsList";
import AddLiveSessions from "./pages/AdminPage/LiveSessions/AddLiveSessions";
import ViewLiveSessions from "./pages/AdminPage/LiveSessions/ViewLiveSessions";
import ClientLayout from "./masterLayout/ClientLayout";
import CourseDetailesView from './pages/ClientPage/CourseDetailes/CourseDetailesView';
import AddonPackDetailesView from './pages/ClientPage/AddonPackDetailes/AddonPackDetailesView';
import ClientDetaileLayout from './masterLayout/ClientDetaileLayout.jsx';
import StudentLogin from './pages/ClientPage/StudentAuthPage/StudentLogin.jsx'
import StudentOtpVerification from './pages/ClientPage/StudentAuthPage/StudentOtpVerification.jsx'
import StudentRegister from './pages/ClientPage/StudentAuthPage/StudentRegister.jsx'
import StudentDashboard from './pages/ClientPage/StudentDashboard/StudentDashboard.jsx'
import CourseStudy from './pages/ClientPage/CourseDetailes/CourseStudy.jsx';
import Lession from './pages/ClientPage/CourseDetailes/Lession.jsx';
import HomeLayout from './masterLayout/HomeLayout.jsx';
import Faq from './pages/ClientPage/Faq.jsx';
import PrivacyPolicy from './pages/ClientPage/PrivacyPolicy.jsx';
import TermsAndConditions from './pages/ClientPage/TermsAndConditions.jsx';
import RefundPolicy from './pages/ClientPage/RefundPolicy.jsx';
import TradingRiskDisclaimer from './pages/ClientPage/TradingRiskDisclaimer.jsx';
import AboutMe from './pages/ClientPage/AboutMe.jsx';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'sweetalert2/dist/sweetalert2.css';

function App() {
  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Routes>
        {/* Protected Routes with Navigation */}
        <Route element={<WithNav />}>
          
          {/* Course Management */}
          <Route path="/course-list" element={<CourseListPage />} />
          <Route path="/add-course" element={<AddCourse />} />
          <Route path="/view-course" element={<ViewCourse />} />
          
          {/* Live Sessions Management */}
          <Route path="/live-sessions-list" element={<LiveSessionsList />} />
          <Route path="/add-live-session" element={<AddLiveSessions />} />
          <Route path="/view-live-session" element={<ViewLiveSessions />} />
          
          {/* Addon Packs Management */}
          <Route path="/addon-packs-list" element={<AddonPacksList />} />
          <Route path="/add-addon-pack" element={<AddAddonPacks />} />
          <Route path="/view-addon-pack" element={<ViewAddonPacks />} />
          
          {/* Vouchers Management */}
          <Route path="/vouchers-list" element={<VouchersList />} />
          <Route path="/add-voucher" element={<AddVouchers />} />
          <Route path="/view-voucher" element={<ViewVouchers />} />

          {/* Announcements Management */}
          <Route path="/announcements-list" element={<AnnouncementsList />} />
          <Route path="/add-announcement" element={<AddAnnouncements />} />
          <Route path="/view-announcement" element={<ViewAnnouncements />} />
        </Route>

        {/* Public Routes without Navigation */}
        <Route element={<WithoutNav />}>
          <Route path="/Admin" element={<SignInLayer />} />
          <Route path="/sign-up" element={<SignUpLayer />} />
          <Route path="/verify-otp" element={<OtpVerification />} />
        </Route>

        <Route element={<ClientLayout />}>
          <Route path="/StudentRegister" element={<StudentRegister />} />
          <Route path="/StudentLogin" element={<StudentLogin />} />
          <Route path="/StudentOtpVerification" element={<StudentOtpVerification />} />
          <Route path="/Faq" element={<Faq />} />
          <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/TermsAndConditions" element={<TermsAndConditions />} />
          <Route path="/RefundPolicy" element={<RefundPolicy />} />
          <Route path="/TradingRiskDisclaimer" element={<TradingRiskDisclaimer />} />
          <Route path="/AboutMe" element={<AboutMe />} />
          <Route path="/course-study" element={<Lession />} />
        </Route>
        <Route element={<HomeLayout />}>
          <Route path="/" element={<HomePage />} />
        </Route>
        <Route element={<ClientDetaileLayout />}>
          <Route path="/coursedetailesview" element={<CourseDetailesView />} />
          <Route path="/addonpackdetailesview" element={<AddonPackDetailesView />} />
          <Route path="/StudentDashboard" element={<StudentDashboard />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
